import { Action } from './base/action.model';

export enum AppActionNames {
  GET_ALL_RESOURCE = '[APP] Get All Resource',
  GET_CRM_STATUS = '[APP] Get CRM Status',
  STORE_USER_PROFILE = '[APP] Store User Profile',
  
}
export class GetAllResource implements Action {
  static readonly type = AppActionNames.GET_ALL_RESOURCE;
  constructor() {}
}
export class GetCRMStatus implements Action {
  static readonly type = AppActionNames.GET_CRM_STATUS;
  constructor() {}
}
export class StoreUserProfile implements Action {
  static readonly type = AppActionNames.STORE_USER_PROFILE;
  constructor(public payload: any) {}
}